import React from 'react';
export function EditorContentIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.414 6L18 1.586 3.148 16.438l-2.076 5.19 1.3 1.3 5.19-2.076L22.414 6zM3.795 20.205l1.057-2.643L18 4.414 19.586 6 6.438 19.148l-2.643 1.057z"
  }), React.createElement("path", {
    d: "M14 3H2v2h10l2-2zM2 7h8L8 9H2V7zm2 6l2-2H2v2h2z"
  }));
}